import React from 'react';
import AppRoutes from './AppRoutes';

// Route to corresponding "page" component based on path.
const App = () => {
  return <AppRoutes />;
};

export default App;
